<template>
  <div class="tabs-container">
    <div class="tabs">
      <!-- 动态背景框 -->
      <div class="tabs-background" :class="{ 'is-mobile-bg': isMobile }" :style="backgroundStyle"></div>

      <!-- tab 按钮 -->
      <div v-for="(tab, index) in tabs" :key="index" class="tab tab-case"
        :class="{ active: tab.value === selectedValue, 'is-mobile-tab-bg': isMobile }" @click="selectTab(index)">
        <div class="label-wrap">
          <slot name="tabName" :tab="tab">{{ tab.label }}</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
export default {
  name: "CustomTabs",
  mixins: [responsiveMixin],
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: "",
    }
  },
  data() {
    return {
      selectedValue: this.value, // 当前选中的
      tabPositions: [], // 存储每个 tab 的位置信息
    };
  },
  computed: {
    backgroundStyle() {
      // 如果 tabPositions 未准备好则不渲染背景框
      const index = this.tabs.findIndex(item => item.value === this.selectedValue);
      if (!this.tabPositions[index]) return {};
      const { width, left } = this.tabPositions[index];
      return {
        width: `${width}px`,
        transform: `translateX(${left}px)`,
      };
    },
  },
  mounted() {
    this.updateTabPositions();
    window.addEventListener("resize", this.updateTabPositions);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTabPositions);
  },
  methods: {
    selectTab(index) {
      this.selectedValue = this.tabs[index].value;
      this.$emit("input", this.selectedValue);
      this.$emit("change", this.tabs[index]);
    },
    updateTabPositions() {
      // 获取每个 tab 的 DOM 位置信息
      this.$nextTick(() => {
        this.tabPositions = Array.from(this.$el.querySelectorAll(".tab-case")).map(
          (tab) => ({
            width: tab.offsetWidth,
            left: tab.offsetLeft,
          })
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
